<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>No Good Deed</title>
<link href="nogooddeed.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=UTF-8"/>
<div class="contents" id="TOC">
<a id="page08">
</a><a id="page09">
<h2 class="contentsHead">Contents</h2>
</a><div class="contentsEntry"><a id="page09">
</a><p class="contentsEntryName1"><a id="page09"></a><a href="#/004epigraphpage#epigraphpage">Epigraph</a></p></div>
<div class="contentsEntry1" id="frontmatterpage_01">
<p class="contentsEntryName1"><a href="#/006frontmatterpage#frontmatterpage01">Author’s Note</a></p></div>
<p class="spaceBreak"> </p>
<div class="contentsEntry" id="chapter_01">
<p class="contentsEntryName"><a href="#/007chapter01#chapter01">1</a> The Police Came Knocking</p></div>
<div class="contentsEntry" id="chapter_02">
<p class="contentsEntryName"><a href="#/008chapter02#chapter02">2</a> Humpty Dumpty</p></div>
<div class="contentsEntry" id="chapter_03">
<p class="contentsEntryName"><a href="#/009chapter03#chapter03">3</a> Setting the Scene</p></div>
<div class="contentsEntry" id="chapter_04">
<p class="contentsEntryName"><span href="#/010chapter04#chapter04" title="Link target outside of Sample">4</span> Rosie</p></div>
<div class="contentsEntry" id="chapter_05">
<p class="contentsEntryName"><span href="#/011chapter05#chapter05" title="Link target outside of Sample">5</span> The Wedding</p></div>
<div class="contentsEntry" id="chapter_06">
<p class="contentsEntryName"><span href="#/012chapter06#chapter06" title="Link target outside of Sample">6</span> Turning Points for Planned Deaths</p></div>
<div class="contentsEntry" id="chapter_07">
<p class="contentsEntryName"><span href="#/013chapter07#chapter07" title="Link target outside of Sample">7</span> It’s a Wonderful Life</p></div>
<div class="contentsEntry" id="chapter_08">
<p class="contentsEntryName"><span href="#/014chapter08#chapter08" title="Link target outside of Sample">8</span> Discontinuing Dialysis</p></div>
<div class="contentsEntry" id="chapter_09">
<p class="contentsEntryName"><span href="#/015chapter09#chapter09" title="Link target outside of Sample">9</span> Understanding Olga</p></div>
<div class="contentsEntry" id="chapter_10">
<p class="contentsEntryName"><span href="#/016chapter10#chapter10" title="Link target outside of Sample">10</span> The Coalition</p></div>
<div class="contentsEntry" id="chapter_11">
<p class="contentsEntryName"><span href="#/017chapter11#chapter11" title="Link target outside of Sample">11</span> Serial Medical Killers</p></div>
<a id="page10">
</a><div class="contentsEntry" id="chapter_12"><a id="page10">
</a><p class="contentsEntryName"><a id="page10"></a><span href="#/018chapter12#chapter12" title="Link target outside of Sample">12</span> Army of God</p></div>
<div class="contentsEntry" id="chapter_13">
<p class="contentsEntryName"><span href="#/019chapter13#chapter13" title="Link target outside of Sample">13</span> Amy Goes Downtown</p></div>
<div class="contentsEntry" id="chapter_14">
<p class="contentsEntryName"><span href="#/020chapter14#chapter14" title="Link target outside of Sample">14</span> More Murder Accusations</p></div>
<div class="contentsEntry" id="chapter_15">
<p class="contentsEntryName"><span href="#/021chapter15#chapter15" title="Link target outside of Sample">15</span> The E-Word Around the World</p></div>
<div class="contentsEntry" id="chapter_16">
<p class="contentsEntryName"><span href="#/022chapter16#chapter16" title="Link target outside of Sample">16</span> Sudden Awakening</p></div>
<div class="contentsEntry" id="chapter_17">
<p class="contentsEntryName"><span href="#/023chapter17#chapter17" title="Link target outside of Sample">17</span> War on Drugs</p></div>
<div class="contentsEntry" id="chapter_18">
<p class="contentsEntryName"><span href="#/024chapter18#chapter18" title="Link target outside of Sample">18</span> The Return</p></div>
<div class="contentsEntry" id="chapter_19">
<p class="contentsEntryName"><span href="#/025chapter19#chapter19" title="Link target outside of Sample">19</span> A View from the Bench</p></div>
<div class="contentsEntry" id="chapter_20">
<p class="contentsEntryName"><span href="#/026chapter20#chapter20" title="Link target outside of Sample">20</span> Moving On</p></div>
<p class="spaceBreak"> </p>
<div class="contentsEntry1" id="acknowledgment_page">
<p class="contentsEntryName2"><span href="#/027acknowledgmentpage#acknowledgmentpage" title="Link target outside of Sample">Acknowledgments</span></p></div>
<div class="contentsEntry1" id="aboutauthor_page">
<p class="contentsEntryName2"><span href="#/028aboutauthorpage#aboutauthorpage" title="Link target outside of Sample">About the Author</span></p>
</div>
<div class="contentsEntry1" id="credits_page">
<p class="contentsEntryName2"><span href="#/029creditspage#creditspage" title="Link target outside of Sample">Credits</span></p>
</div>
<div class="contentsEntry1" id="copyright_page">
<p class="contentsEntryName2"><span href="#/030copyrightpage#copyrightpage" title="Link target outside of Sample">Copyright</span></p></div>
<div class="contentsEntry1" id="aboutpublisher_page">
<p class="contentsEntryName2"><span href="#/031aboutpublisherpage#aboutpublisherpage" title="Link target outside of Sample">About the Publisher</span></p></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005TOC.vue?1f41541a